import Vue from 'vue';
import Component from 'vue-class-component';
import { ED_TOAST_EVENTS } from '../../ed-toast.plugin';
import { IPropCreateToast } from '../../interfaces/prop-create-toast.interface';
import { TOAST_TYPES } from '../../values/ed-toast.values';

@Component({})
export default class EdToastMsg extends Vue {

  public props: IPropCreateToast = {
    type: TOAST_TYPES.INFO,
    msg: '',
    timeout: 3000,
    top: '0'
  };

  public toastCreated: boolean = false;
  public isShowing: boolean = false;
  public toastTimeout: any = null;

  get type() {
    return this.props.type ? this.props.type : TOAST_TYPES.INFO;
  }

  get msg() {
    return this.props.msg;
  }

  get timeout(): number {
    return this.props.timeout ? this.props.timeout : 0;
  }

  showToast(props: IPropCreateToast) {
    this.props = props; 
    this.toastCreated = true;
    setTimeout(() => {
      this.compileRouterLinkTemplate();
      this.isShowing = true;
      if(this.timeout) {
        this.setToastTimeout();
      }
    }, 100);
  }

  setToastTimeout() {
    this.toastTimeout = setTimeout(() => {
      this.hideToast();
    }, this.timeout)
  }

  hideToast() {
    this.isShowing = false;
    setTimeout(() => {
      this.toastCreated = false;
      this.toastTimeout = null;
    }, 300);
  }

  updateToast(props: IPropCreateToast) {
    this.props = props;
    if(props.timeout) {
      this.setToastTimeout();
    }
  }

  created() {
    this.$EdToast.$on(ED_TOAST_EVENTS.SHOW, this.showToast);
    this.$EdToast.$on(ED_TOAST_EVENTS.UPDATE, this.updateToast);
    this.$EdToast.$on(ED_TOAST_EVENTS.HIDE, this.hideToast);
  }

  destroyed() {
    if(this.toastTimeout) { 
      clearTimeout(this.toastTimeout);
    }
    this.$EdToast.$off(ED_TOAST_EVENTS.SHOW, this.showToast);
  }


  //based on: https://levelup.gitconnected.com/vue-js-replace-a-with-router-link-in-dynamic-html-c423beea0d17
  compileRouterLinkTemplate() {
    let parent:any = this.$el.parentNode;
    const anchors = parent.getElementsByTagName('router-link');
    Array.from(anchors).forEach((anchor:any) => {
        const url = anchor.getAttribute(':to');
        const propsData = { to: url };
        const parent = this;
        const RouterLink = Vue.component('RouterLink');
        const routerLink = new RouterLink({ propsData, parent });
        routerLink.$mount(anchor); //replaces anchor element
        routerLink.$el.innerHTML = anchor.innerHTML;
    });
  }

}